import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { EmptyIterator_instancex3sopkoseugu as EmptyIterator_instance } from './CollectionsKt.mjs';
import { iterator3f5i676wpaa3g as iterator } from '../sequences/SequenceBuilder.mjs';
import { AbstractIterator1svf7vpi1lw8y as AbstractIterator } from './AbstractIterator.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import {
  AbstractList3ck35puwbp1e9 as AbstractList,
  Companion_instance2ztfx9zvq7j5d as Companion_instance,
} from './AbstractList.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { isArray1hxjqtqy632bc as isArray } from '../js/typeCheckUtils.mjs';
import {
  copyOf2ng0t8oizk6it as copyOf,
  fill3hcjvebk42tyx as fill,
} from './_ArraysJs.mjs';
import { terminateCollectionToArray12671uhv05xea as terminateCollectionToArray } from './collectionJs.mjs';
import { coerceAtMost322komnqp70ag as coerceAtMost } from '../ranges/_Ranges.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from './ArrayListJs.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function checkWindowSizeStep(size, step) {
  // Inline function 'kotlin.require' call
  if (!(size > 0 && step > 0)) {
    var message = !(size === step) ? 'Both size ' + size + ' and step ' + step + ' must be greater than zero.' : 'size ' + size + ' must be greater than zero.';
    throw IllegalArgumentException().o2(toString(message));
  }
}
function windowedIterator(iterator_0, size, step, partialWindows, reuseBuffer) {
  if (!iterator_0.q1())
    return EmptyIterator_instance;
  return iterator(windowedIterator$slambda(size, step, iterator_0, reuseBuffer, partialWindows));
}
var RingBuffer$iterator$1Class;
function RingBuffer$iterator$1() {
  if (RingBuffer$iterator$1Class === VOID) {
    class $ extends AbstractIterator() {
      constructor(this$0, $box) {
        if ($box === VOID)
          $box = {};
        $box.qm_1 = this$0;
        super($box);
        this.om_1 = this$0.um_1;
        this.pm_1 = this$0.tm_1;
      }
      wi() {
        if (this.om_1 === 0) {
          this.yi();
        } else {
          this.xi(this.qm_1.rm_1[this.pm_1]);
          var tmp = this;
          var tmp0 = this.qm_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          tmp.pm_1 = (this.pm_1 + 1 | 0) % tmp0.sm_1 | 0;
          this.om_1 = this.om_1 - 1 | 0;
        }
      }
    }
    initMetadataForClass($);
    RingBuffer$iterator$1Class = $;
  }
  return RingBuffer$iterator$1Class;
}
var RingBufferClass;
function RingBuffer() {
  if (RingBufferClass === VOID) {
    class $ extends AbstractList() {
      constructor(buffer, filledSize) {
        return new.target.vm(buffer, filledSize);
      }
      static vm(buffer, filledSize) {
        var $this = this.dj();
        $this.rm_1 = buffer;
        // Inline function 'kotlin.require' call
        if (!(filledSize >= 0)) {
          var message = 'ring buffer filled size should not be negative but it is ' + filledSize;
          throw IllegalArgumentException().o2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(filledSize <= $this.rm_1.length)) {
          var message_0 = 'ring buffer filled size: ' + filledSize + ' cannot be larger than the buffer size: ' + $this.rm_1.length;
          throw IllegalArgumentException().o2(toString(message_0));
        }
        $this.sm_1 = $this.rm_1.length;
        $this.tm_1 = 0;
        $this.um_1 = filledSize;
        return $this;
      }
      static wm(capacity) {
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp$ret$0 = Array(capacity);
        return this.vm(tmp$ret$0, 0);
      }
      q2() {
        return this.um_1;
      }
      r2(index) {
        Companion_instance.j7(index, this.um_1);
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.tm_1 + index | 0) % this.sm_1 | 0;
        return this.rm_1[tmp$ret$0];
      }
      xm() {
        return this.um_1 === this.sm_1;
      }
      p1() {
        return new (RingBuffer$iterator$1())(this);
      }
      ck(array) {
        var tmp;
        if (array.length < this.um_1) {
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = this.um_1;
          tmp = copyOf(array, newSize);
        } else {
          tmp = isArray(array) ? array : THROW_CCE();
        }
        var result = tmp;
        var size = this.um_1;
        var widx = 0;
        var idx = this.tm_1;
        while (widx < size && idx < this.sm_1) {
          result[widx] = this.rm_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        idx = 0;
        while (widx < size) {
          result[widx] = this.rm_1[idx];
          widx = widx + 1 | 0;
          idx = idx + 1 | 0;
        }
        var tmp_0 = terminateCollectionToArray(size, result);
        return isArray(tmp_0) ? tmp_0 : THROW_CCE();
      }
      j8() {
        // Inline function 'kotlin.arrayOfNulls' call
        var size = this.um_1;
        var tmp$ret$0 = Array(size);
        return this.ck(tmp$ret$0);
      }
      toArray() {
        return this.j8();
      }
      ym(maxCapacity) {
        var newCapacity = coerceAtMost((this.sm_1 + (this.sm_1 >> 1) | 0) + 1 | 0, maxCapacity);
        var tmp;
        if (this.tm_1 === 0) {
          // Inline function 'kotlin.collections.copyOf' call
          var this_0 = this.rm_1;
          tmp = copyOf(this_0, newCapacity);
        } else {
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp$ret$1 = Array(newCapacity);
          tmp = this.ck(tmp$ret$1);
        }
        var newBuffer = tmp;
        return RingBuffer().vm(newBuffer, this.um_1);
      }
      zm(element) {
        if (this.xm()) {
          throw IllegalStateException().o('ring buffer is full');
        }
        // Inline function 'kotlin.collections.RingBuffer.forward' call
        var tmp$ret$0 = (this.tm_1 + this.um_1 | 0) % this.sm_1 | 0;
        this.rm_1[tmp$ret$0] = element;
        this.um_1 = this.um_1 + 1 | 0;
      }
      an(n) {
        // Inline function 'kotlin.require' call
        if (!(n >= 0)) {
          var message = "n shouldn't be negative but it is " + n;
          throw IllegalArgumentException().o2(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(n <= this.um_1)) {
          var message_0 = "n shouldn't be greater than the buffer size: n = " + n + ', size = ' + this.um_1;
          throw IllegalArgumentException().o2(toString(message_0));
        }
        if (n > 0) {
          var start = this.tm_1;
          // Inline function 'kotlin.collections.RingBuffer.forward' call
          var end = (start + n | 0) % this.sm_1 | 0;
          if (start > end) {
            fill(this.rm_1, null, start, this.sm_1);
            fill(this.rm_1, null, 0, end);
          } else {
            fill(this.rm_1, null, start, end);
          }
          this.tm_1 = end;
          this.um_1 = this.um_1 - n | 0;
        }
      }
    }
    initMetadataForClass($, 'RingBuffer', VOID, VOID, [RandomAccess()]);
    RingBufferClass = $;
  }
  return RingBufferClass;
}
function windowedIterator$slambda($size, $step, $iterator, $reuseBuffer, $partialWindows) {
  return constructCallableReference(($this$iterator, $completion) => orPromise($completion, function *($completion) {
    var bufferInitialCapacity = coerceAtMost($size, 1024);
    var gap = $step - $size | 0;
    var tmp;
    if (gap >= 0) {
      var buffer = ArrayList().i2(bufferInitialCapacity);
      var skip = 0;
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = $iterator;
      $l$loop: while (_iterator__ex2g4s.q1()) {
        var e = _iterator__ex2g4s.r1();
        if (skip > 0) {
          skip = skip - 1 | 0;
          continue $l$loop;
        }
        buffer.j2(e);
        if (buffer.q2() === $size) {
          yield* $this$iterator.hl(buffer, $completion);
          if ($reuseBuffer) {
            buffer.y4();
          } else
            buffer = ArrayList().i2($size);
          skip = gap;
        }
      }
      var tmp_0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!buffer.n1()) {
        tmp_0 = $partialWindows || buffer.q2() === $size ? (yield* $this$iterator.hl(buffer, $completion)) : void 0;
      }
      tmp = tmp_0;
    } else {
      var buffer_0 = RingBuffer().wm(bufferInitialCapacity);
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_0 = $iterator;
      $l$loop_0: while (_iterator__ex2g4s_0.q1()) {
        var e_0 = _iterator__ex2g4s_0.r1();
        buffer_0.zm(e_0);
        if (buffer_0.xm()) {
          if (buffer_0.um_1 < $size) {
            buffer_0 = buffer_0.ym($size);
            continue $l$loop_0;
          }
          yield* $this$iterator.hl($reuseBuffer ? buffer_0 : ArrayList().k2(buffer_0), $completion);
          buffer_0.an($step);
        }
      }
      var tmp_1;
      if ($partialWindows) {
        while (buffer_0.um_1 > $step) {
          yield* $this$iterator.hl($reuseBuffer ? buffer_0 : ArrayList().k2(buffer_0), $completion);
          buffer_0.an($step);
        }
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!buffer_0.n1()) {
          tmp_2 = yield* $this$iterator.hl(buffer_0, $completion);
        }
        tmp_1 = tmp_2;
      }
      tmp = tmp_1;
    }
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  checkWindowSizeStep as checkWindowSizeStepcg5bise2nnst,
  windowedIterator as windowedIterator1l52d653czu3r,
};
//endregion

//# sourceMappingURL=SlidingWindow.mjs.map
